import {
  competitionConstants,
  globalConstants,
  modeConstants,
  screenNameConstants,
} from "../../constants";

const initialState = {
  page: {},
  pageData: [],
  viewMode: modeConstants.ADD_MODE,
  isViewModal: false,
  competitionData: [],
  competitionPublicData: {},
  competitionDataById: {},
  competitionPublicDataById: {},
  isParticipantsValidated: false,
  BoatTypeIds: {},
  myCompetitionsData: {},
  competitionGeneralDetail: {},
  competitionParticipantsDetail: [],
  paticipantEmailData: {},
  uploadedFile: {},
  competitionStats: {},
  isUpcomingScreen: false,
  competitionFeedbackQuestion: [],
  competitionViewResult: {},
  competitionfeedback: {},
  userBoatClassses: [],
  competitionTotalPaymentById: null,
  leaderboardBoatClasses: [],
};

const CompetitionReducer = (state = initialState, action) => {
  switch (action.type) {
    case competitionConstants.VIEW_ADD_COMPETITION + globalConstants.SUCCESS:
      return {
        ...state,
        viewMode: action.data,
      };
    case competitionConstants.COMPETITION_MODAL + globalConstants.SUCCESS:
      return {
        ...state,
        isViewModal: action.data,
      };
    case competitionConstants.COMPETITION_DATA_ID + globalConstants.SUCCESS:
      return {
        ...state,
        competitionDataById: action.data,
      };
    case competitionConstants.COMPETITION_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        page: action.data.page,
        pageData: action.data.pageData,
        competitionData: action.data,
      };
    case competitionConstants.COMPETITION_PUBLIC_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        competitionPublicData: action.data,
      };
    case competitionConstants.COMPETITION_PUBLIC_DATA_ID +
      globalConstants.SUCCESS:
      return {
        ...state,
        competitionPublicDataById: action.data,
      };
    case competitionConstants.MY_COMPETITION_DATA + globalConstants.SUCCESS:
      return {
        ...state,
        myCompetitionsData: action.data,
      };
    case competitionConstants.VALIDATE_PARTICIPANTS_COMPETITION +
      globalConstants.SUCCESS:
      return {
        ...state,
        isParticipantsValidated: true,
        userBoatClass: action.data.payload.classes,
      };
    case competitionConstants.VALIDATE_PARTICIPANTS_FALSE:
      return {
        ...state,
        isParticipantsValidated: false,
        userBoatClass: [],
      };
    case competitionConstants.GET_COMPETITION_GENERAL_DATA +
      globalConstants.SUCCESS:
      return {
        ...state,
        isUpcomingScreen:
          action.data.screen === screenNameConstants.VIEW_UPCOMING_COMPETITIONS
            ? true
            : false,
        competitionGeneralDetail: action.data,
      };
    case competitionConstants.GET_COMPETITION_PARTICIPANTS_DATA +
      globalConstants.SUCCESS:
      return {
        ...state,
        competitionParticipantsDetail: action.data,
      };
    case competitionConstants.GET_COMPETITION_PARTICIPANTS_BY_EMAIL +
      globalConstants.SUCCESS:
      return {
        ...state,
        paticipantEmailData: action.data,
      };
    case competitionConstants.COMPETITION_PARTICIPANTS_BY_EMAIL_NULL:
      return {
        ...state,
        paticipantEmailData: null,
      };
    case competitionConstants.GET_UPLOADED_FILE + globalConstants.SUCCESS:
      return {
        ...state,
        uploadedFile: action.data,
      };
    case competitionConstants.GET_COMPETITION_STATS + globalConstants.SUCCESS:
      return {
        ...state,
        competitionStats: action.data,
      };
    case competitionConstants.GET_COMPETITION_FEEDBACK_QUESTION +
      globalConstants.SUCCESS:
      return {
        ...state,
        competitionFeedbackQuestion: action.data.data,
      };
    case competitionConstants.GET_COMPETITION_DETAIL_RESULT +
      globalConstants.SUCCESS:
      return {
        ...state,
        competitionViewResult: action.data,
      };
    case competitionConstants.GET_COMPETITION_FEEDBACK +
      globalConstants.SUCCESS:
      return {
        ...state,
        competitionfeedback: action.data,
      };
    case competitionConstants.COMPETITION_TOTAL_PAYMENT_BY_ID_DATA +
      globalConstants.SUCCESS:
      return {
        ...state,
        competitionTotalPaymentById: action.data,
      };
    case competitionConstants.COMP_LEADERBOARD_BOAT_CLASSES +
      globalConstants.SUCCESS:
      return {
        ...state,
        leaderboardBoatClasses: action.data,
      };
    default:
      return state;
  }
};

export default CompetitionReducer;
